<template>
    <v-dialog max-width="50%" v-model="dialog">
        <v-card class="ma-0 pa-0">
            <v-card-actions class="ma-0 pa-0">
                <v-btn icon class="ma-1" color="red" @click="onDelete" :loading="deleting">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn icon class="ma-1" color="red" @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>
            <v-card-actions class="py-0 mt-4">
                <v-text-field
                        outlined
                        v-model="folderName"
                        label="Folder Name"
                ></v-text-field>
            </v-card-actions>
            <v-card-actions class="mt-n5">
                <v-spacer></v-spacer>
                <v-btn :loading="loading"
                       class="ma-2"
                       color="primary"
                       @click="onPressSave">SAVE
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {UsersBackendUtils} from "@/modules/mprofiles/database/UsersBackendUtils";

export default {
    name: "popup-edit-snapshot-folder",
    props: {},
    components: {},
    data: () => ({
        dialog: false,
        folder: null,
        folderName: '',
        loading:false,
        deleting:false,
    }),
    computed: {
    },
    methods: {
        show(folder) {
            this.folderName = folder == null ? '' : folder.name
            this.dialog = true
            this.folder = folder
        },
        hide() {
            this.dialog = false
        },
        onDelete(){
            this.deleting = true;
            this.$confirm("Are you sure?").then(() => {
                UsersBackendUtils.removeSnapFolder(this.folder.fid).then(() => {
                    this.$notify({title: 'Folder successfully removed!', type: "success"});
                    this.deleting = false;
                    this.hide()
                }).catch((error) => {
                    this.$notify({title: 'Folder remove failed!', text: error, type: "error"});
                    this.deleting = false;
                    this.hide()
                })
            }).catch(() => {})
        },
        onClose() {
            this.hide()
        },
        onPressSave() {
            if (this.folderName.length == 0){
                this.$notify({title: 'Empty folder name!', type: "error"});
                return;
            }
            this.loading = true;
            UsersBackendUtils.setSnapshotFolderName({folder_id:this.folder.fid, folder_name:this.folderName}).then(() => {
                this.$notify({title: 'Folder successfully renamed!', type: "success"});
                this.loading = false;
                this.hide()
            }).catch((error) => {
                this.$notify({title: 'Folder rename failed!', text: error, type: "error"});
                this.loading = false;
                this.hide()
            })
        },
    },
}
</script>

<style scoped>

</style>